import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { VERSION_FIELD_DESCRIPTOR } from './_versionField.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { SAVED_SELECTION } from '../types/saved-selection.js';
import { USER_DATA } from '../types/user.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for SavedSelection — named filter/layout presets (spec 0047 fase 3).
 * Stored in 'org/{orgId}/saved-selection'. No lifecycle (delete, do not inactivate).
 */
export const savedSelectionDescriptor = {
    name: SAVED_SELECTION,
    label: 'Seleção salva',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/saved-selection',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Named saved selection (filter + layout) for dynamic grids',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: versioned entity (spec 0045) — stale cache would hide conflicts.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    /** Opening a screen lists by entity + screen + user (org rows have null userId). */
    indexes: [{ fields: ['entity', 'screen', 'userId'] }],
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique selection identifier',
        },
        {
            name: 'entity',
            label: 'Entidade',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_ENTITY_NAME,
            description: 'Descriptor name of the filtered entity',
        },
        {
            name: 'screen',
            label: 'Tela',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.SAVED_SELECTION_SCREEN,
            description: 'PaginatedCrudPage name; null/empty = all screens of the entity',
        },
        {
            name: 'name',
            label: 'Nome',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Display name; ignored for pointer rows',
        },
        {
            name: 'userId',
            label: 'Usuário',
            type: 'string',
            required: false,
            description: 'Owner user id; null = organization selection',
        },
        {
            name: 'isDefault',
            label: 'Padrão',
            type: 'boolean',
            required: true,
            description: 'Applied when opening the screen (scoped per entity/screen/user)',
        },
        {
            name: 'baseSelectionId',
            label: 'Seleção base',
            type: 'string',
            required: false,
            description: 'Pointer to another selection (usually org); layout must be empty',
        },
        {
            name: 'layout',
            label: 'Layout',
            type: 'object',
            required: false,
            description: 'Opaque DynamicQueryLayout v2 (JSONB in Postgres). Size capped via L1 on JSON.stringify.',
        },
        ...AUDIT_FIELD_DESCRIPTORS,
        VERSION_FIELD_DESCRIPTOR,
    ],
    foreignKeys: [
        {
            fieldName: 'userId',
            targetEntity: USER_DATA,
            relationship: 'many-to-one',
            displayField: 'name',
            expand: false,
        },
        {
            fieldName: 'baseSelectionId',
            targetEntity: SAVED_SELECTION,
            relationship: 'many-to-one',
            displayField: 'name',
            expand: false,
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=saved-selection.descriptor.js.map